module.exports = __webpack_public_path__ + "static/img/viral_26.dd58773b.jpg";